import { Semanticpmpmvt7fldq2 as Semantic } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Companion_getInstance2eccs74uj90kl as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { FormHeader_getInstance1rs49tmvkejrt as FormHeader_getInstance } from '../theming/formThemes.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { xlTitle2v7mu4p1j9wv3 as xlTitle } from '../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { infoBubblebw7xb14ivkdr as infoBubble } from './iconShortcuts.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { get_secondaryButtondor94xxt3ws3 as get_secondaryButton } from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0 } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AdjacentCardsSemanticClass;
function AdjacentCardsSemantic() {
  if (AdjacentCardsSemanticClass === VOID) {
    class $ extends Semantic() {
      static si1() {
        AdjacentCardsSemantic_instance = null;
        var $this = this.bd1('adjcrds');
        AdjacentCardsSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        return this.hd1(theme, false, VOID, VOID, VOID, get_px(0), Companion_getInstance().zcz_1);
      }
      toString() {
        return 'AdjacentCardsSemantic';
      }
      hashCode() {
        return -396373863;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AdjacentCardsSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'AdjacentCardsSemantic');
    AdjacentCardsSemanticClass = $;
  }
  return AdjacentCardsSemanticClass;
}
var AdjacentCardsSemantic_instance;
function AdjacentCardsSemantic_getInstance() {
  if (AdjacentCardsSemantic_instance === VOID)
    AdjacentCardsSemantic().si1();
  return AdjacentCardsSemantic_instance;
}
function signOffHeader(_this__u8e3s4, title, info, close) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_px(0));
  var tmp = view.ibb(get_expanding(view), view.hbb(FormHeader_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_0 = view_0.ibb(get_centered(view_0), get_compact(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.jbb(get_centered(view_1), xlTitle(view_1, title));
  view_1.jbb(get_centered(view_1), infoBubble(view_1, info));
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  if (!(close == null)) {
    var tmp_1 = view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(3.5)), get_secondaryButton(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view_2.jbb(get_centered(view_2), icon(view_2, Companion_getInstance_0().tcf_1, 'Close Form'));
    onClick(view_2, VOID, VOID, signOffHeader$slambda_0(close));
    view.fbb(p_2, view_2);
    view.jbb(tmp_1, view_2);
  }
  _this__u8e3s4.fbb(p, view);
}
var signOffHeader$slambdaClass;
function signOffHeader$slambda() {
  if (signOffHeader$slambdaClass === VOID) {
    class $ {
      constructor($close) {
        this.ti1_1 = $close;
      }
      sao($completion) {
        this.ti1_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    signOffHeader$slambdaClass = $;
  }
  return signOffHeader$slambdaClass;
}
function signOffHeader$slambda_0($close) {
  var i = new (signOffHeader$slambda())($close);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  signOffHeader as signOffHeader11hami6texki7,
  AdjacentCardsSemantic_getInstance as AdjacentCardsSemantic_getInstance26qn2so7ofz0z,
};
//endregion

//# sourceMappingURL=signOffHeader.mjs.map
